<template>
  <!-- 阅卷管理 列表页 -->
    <div class="board">
        <div v-hasPermi="['review:list']">
            <div class="title">
                <span class="name">{{ markingTextConfig.title }}</span>
            </div>
            <el-form :inline="true" :model="form" ref="form">
                <el-form-item>
                    <el-select v-model="form.examPlanId" filterable clearable :placeholder="searchTextConfig.examPlan">
                        <el-option v-for="(item, index) in examPlanOptions" :key="index" :label="item.name"
                                   :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="form.subjectId" filterable clearable :placeholder="searchTextConfig.subject">
                        <el-option v-for="(item,index) in subjectOptions" :key="index" :label="item.name"
                                   :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="form.examPaperId" filterable clearable
                               :placeholder="searchTextConfig.examPaper">
                        <el-option v-for="(item,index) in paperNameOptions" :key="index" :label="item.name"
                                   :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="form.questionSort" clearable :placeholder="searchTextConfig.question">
                        <el-option v-for="item in questionOptions" :key="item" :label="subjectivityLabel + item"
                                   :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="form.reviewStatus" clearable :placeholder="searchTextConfig.status">
                        <el-option v-for="item in statusOptions" :key="item.dict_value" :label="item.dict_label"
                                   :value="item.dict_value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search(1)">{{ searchTextConfig.select }}</el-button>
                    <el-button @click="reset">{{ searchTextConfig.reset }}</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="tableData" v-loading="loading" element-loading-text="加载中"
                      element-loading-spinner="el-icon-loading" ref="multipleTable" stripe size="medium"
                      :height="height" style="width:100%">
                <el-table-column prop="exam.examPlanName" :label="tableTextConfig.examPlan" min-width="170px"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="exam.subject" :label="tableTextConfig.subject" min-width="170px"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="exam.examPaperName" :label="tableTextConfig.examPaperName" min-width="120px"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="exam.examPaperName" :label="tableTextConfig.questionSort" min-width="90px">
                    <template slot-scope="scope">
                        {{ subjectivityLabel }}{{ scope.row.questionSort }}
                    </template>
                </el-table-column>
                <el-table-column prop="exam.examTime" :label="tableTextConfig.examTime" min-width="170px" :formatter="examTimeFormatter"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="exam.reviewStartTime" :label="tableTextConfig.reviewStartTime" min-width="170px"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="exam.reviewEndTime" :label="tableTextConfig.reviewEndTime" min-width="170px"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column :label="tableTextConfig.schedule" min-width="80px">
                    <template slot-scope="scope">
                        {{ scope.row.reviewedNum }} / {{ scope.row.reviewTotal }}
                    </template>
                </el-table-column>
                <el-table-column fixed="right" :label="tableTextConfig.operate" min-width="80px">
                    <template slot-scope="scope">
                        <el-button v-hasPermi="['review:testPaper:list']" plain type="primary" size="mini"
                                   @click="lookPaper(scope.row)">{{ tableTextConfig.button.details.name }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination v-show="tableData.length" :currentPage.sync="form.pageNumber" :pageSize.sync="form.pageSize"
                        :total.sync="total"></pagination>
        </div>
    </div>
</template>

<script>
import pagination from '@/components/pagination/pagination.vue'
import {getDict} from "@/api/dict"

export default {
    name: 'marking',
    components: {
        pagination
    },
    data() {
        return {
            height: 250,
            loading: true,
            form: {
                examPlanId: '',
                subjectId: '',
                examPaperId: '',
                reviewStatus: '',
                questionSort: '',
                pageNumber: 1,
                pageSize: 20
            },
            total: 0,
            examPlanOptions: [],
            subjectOptions: [],
            paperNameOptions: [],
            questionOptions: [],
            statusOptions: [],
            tableData: [],
            row: null,
            subjectivityLabel: ""
        }
    },
    computed: {
        markingTextConfig() {
            return this.$store.state.global.textConfig.backend.marking
        },
        searchTextConfig() {
            return this.markingTextConfig.search
        },
        tableTextConfig() {
            return this.markingTextConfig.table
        },
    },
    watch: {
        tableData() {
            if (this.tableData.length == 0) {
                this.height = 120
            } else {
                this.updateHeight()
            }
        }
    },
    methods: {
        search(val) {
            this.loading = true
            if (val) {
                this.form.pageNumber = val
            }
            this.$store.dispatch("getMarkingList", this.form).then(res => {
                if (res.status == 200) {
                    this.tableData = res.data.list
                    this.total = res.data.total
                }
                this.loading = false
                this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
            }).catch(err => {
                this.loading = false
            })
        },
        reset() {
            this.form = this.$options.data().form
            this.form.pageSize = 20
            this.search(1)
        },
        updateHeight() {
            if (document.getElementsByClassName('el-form')[0]) {
                this.height = document.getElementsByClassName('board')[0].clientHeight - document.getElementsByClassName('el-form')[0].clientHeight - 150
                this.height = this.height < 460 ? 460 : this.height
            }
        },
        lookPaper(data) {
            localStorage.setItem('setMarkingPaperInfo', JSON.stringify(data))
            this.$router.push({name: 'markingPaper'})
        },
        examTimeFormatter(row) {
            return row.exam.startTime + ' ~ ' + row.exam.endTime
        }
    },
    created() {
        getDict('review_status').then(res => {
            this.statusOptions = res.data.filter(item => item.dict_value != 3)
        })
        getDict('question_type').then(res => {
            let subjectivity = res.data.find(item => item.dict_value == 'subjectivity')
            this.subjectivityLabel = subjectivity ? subjectivity.dict_label : '主观题'
        })
        this.$store.dispatch("getExamPlan").then(res => {
            this.examPlanOptions = res.data
        });
        this.$store.dispatch("getExamSubject").then(res => {
            this.subjectOptions = res.data
        });
        this.$store.dispatch("getArrangementExamPaper").then(res => {
            this.paperNameOptions = res.data
        });
        this.$store.dispatch("postReviewQuestion").then(res => {
            this.questionOptions = res.data
        });
        this.search(1)
    },
    mounted() {
        const that = this;
        setTimeout(() => {
            that.updateHeight()
        }, 200);
        window.onresize = () => {
            that.updateHeight()
        };
    },
}
</script>

<style scoped>
</style>